import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ModelState {
    isOpenModel: boolean,
    instructionText : string,
    selectedOTPid : string;

}

const initialState: ModelState = {
    isOpenModel : false,
    instructionText : '',
    selectedOTPid: ''
};

const modelSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {
    setIsOpenModel(state, action: PayloadAction<boolean>) {
      state.isOpenModel = action.payload; // Set the loading state
    },
    setInstructionText(state, action: PayloadAction<{text : string,id: string}>) {
      state.instructionText = action.payload.text;
      state.selectedOTPid = action.payload.id;
    }
  },
});

export const { 
    setIsOpenModel, setInstructionText
} = modelSlice.actions;

export default modelSlice.reducer;
